import React from 'react'

import { SiteContext } from 'context/site-context'

import {
  getGeoFromLocalStorage,
  getLocationFromZip,
} from 'helpers'

import BusinessCards from 'components/atoms/BusinessCards'
import Categories from 'components/sections/Categories'
import Featured from 'components/atoms/Featured'
import Pagination from 'components/atoms/Pagination'
import PriorityListing from 'components/atoms/PriorityListing'
import SearchForm from 'components/atoms/SearchForm'
import TopBusinesses from 'components/atoms/TopBusinesses'

import './index.scss'

const DirectoryList = props => {
  const [ site ] = React.useContext(SiteContext)

  const [ state, setState ] = React.useState({
    location: new URLSearchParams(window.location.search).get('where') || site.location || getGeoFromLocalStorage()?.location || '',
    term: new URLSearchParams(window.location.search).get('term') || '',
    categoryId: new URLSearchParams(window.location.search).get('categoryId') || '',
    page: new URLSearchParams(window.location.search).get('page') ? parseInt(new URLSearchParams(window.location.search).get('page')) : 1,
    rpp: new URLSearchParams(window.location.search).get('rpp') ? parseInt(new URLSearchParams(window.location.search).get('rpp')) : 10,
    total: 0,
    isEmpty: false,
    isLoading: true,
    results: [],
  })

  const [ priorityListing ] = React.useState()

  // const cleanResults = (data = []) => {
  //   const results = data.map( result => {
  //     return {
  //       ...result.importedListing.importedListing,
  //       images: result.importedListing.images,
  //       reviews: result.importedListing.reviews,
  //       video: result.importedListing.video,
  //       impression: result.impression,
  //     }
  //   })
  //   return results
  // }

  const cleanLocation = (location = '') => {
    let _location;

    _location = location.split(', ')
    if(_location.length === 2){
      return {
        city: _location[0].trim(),
        state: _location[1].trim()
      }
    }

    _location = location.split(',')
    if(_location.length === 2){
      return {
        city: _location[0].trim(),
        state: _location[1].trim()
      }
    }

    _location = location.split(' ')
    if(_location.length === 2){
      return {
        city: _location[0].trim(),
        state: _location[1].trim()
      }
    }
    if(_location.length > 2){
      const i = location.lastIndexOf(' ')
      return {
        city: location.substring(0, i).trim(),
        state: location.substring(i).trim()
      }
    }
    if(_location.length < 2){
      return {
        city: location.trim(),
        state: '',
      }
    }
  }

  const isZip = str => (/^[0-9]{5}(?:-[0-9]{4})?$/).test(str)

  const parseLocation = (location = '') => {
    if(isZip(location)){
      return `postalCode: "${location}"`
    }

    let _location;

    _location = location.split(', ')
    if(_location.length === 2){
      return `city: "${_location[0].trim()}", state: "${_location[1].trim()}"`
    }

    _location = location.split(',')
    if(_location.length === 2){
      return `city: "${_location[0].trim()}", state: "${_location[1].trim()}"`
    }

    _location = location.split(' ')
    if(_location.length === 2){
      return `city: "${_location[0].trim()}", state: "${_location[1].trim()}"`
    }
    if(_location.length > 2){
      const i = location.lastIndexOf(' ')
      return `city: "${location.substring(0, i).trim()}", state: "${_location[1].trim()}"`
    }
    if(_location.length < 2){
      return `city: "${location.substring(0, i).trim()}"`
    }
  }

  React.useEffect( () => {
    async function loadData() {
      if(isZip(state.location)){
        try {
          getLocationFromZip(state.location, data => {
            setState( prevState => ({
              ...prevState,
              city: data.city,
              region: data.region,
              zip_code: data.zip_code,
            }))
          })
        } catch(e){
          console.debug(e)
        }
      }

      try {
        const response = await fetch('https://apis.elocal.com/citygrid/graphql', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            query: `{
              distributionSearch(
                request: {
                  searchTerm: "${state.term}",
                  ${parseLocation(state.location)},
                  affiliateIntegrationCode: "citysearch"
                }
              ) {
                importedListing {
                  importedListing {
                    importedListingId
                    listingId
                    listingName
                    listingType
                    street1
                    street2
                    city
                    stateOrProvince
                    postalCode
                    organicPhone
                    services {
                      id
                      name
                    }
                  }
                  images {
                    imageId
                    primary
                    originalUrl
                  }
                }
              }
            }`
          })
        }).catch( e => {
          console.debug(e)
          const results = site.results?.static || []
          setState( prevState => ({
            ...prevState,
            isEmpty: results.length === 0,
            results: results,
            isLoading: false,
          }))
        })

        const json = await response.json()

        if(json.errors){
          console.debug(JSON.stringify(json.errors))
          const results = site.results?.static || []
          setState( prevState => ({
            ...prevState,
            isEmpty: results.length === 0,
            results: results,
            isLoading: false,
            total: results.length,
          }))
        } else {
          const results = (json?.data?.distributionSearch || []).concat(site.results?.static || [])
            .map( result => {
              return {
                ...result.importedListing.importedListing,
                images: result.importedListing.images
              }} )
          setState( prevState => ({
            ...prevState,
            isEmpty: !results.length,
            results: results,
            isLoading: false,
            total: json?.results?.total_hits,
          }))
        }
      } catch(e){
        console.debug('e', e)
        const results = site.results?.static || []
        setState( prevState => ({
          ...prevState,
          isEmpty: results.length === 0,
          results: results,
          isLoading: false,
          total: results.length,
        }))
      }
    }
    !site.isLoadingSiteData && loadData()
  }, [site.isLoadingSiteData, state.page])

  // React.useEffect( () => {
  //   async function loadPriorityListingData() {
  //     if(isZip(state.location)){
  //       try {
  //         getLocationFromZip(state.location, data => {
  //           setState( prevState => ({
  //             ...prevState,
  //             city: data.city,
  //             region: data.region,
  //             zip_code: data.zip_code,
  //           }))
  //         })
  //       } catch(e){
  //         console.debug(e)
  //       }
  //     }
  //
  //     const useSampleData = new URLSearchParams(window.location.search).get('useSampleData')
  //
  //     if(useSampleData) {
  //       setPriorityListing({
  //         ...SAMPLE_PRIORITY_LISTING.ads[0],
  //       })
  //     } else {
  //       try {
  //         const url = `https://api.citygridmedia.com/pfp/pl?what=${state.term}&where=${isZip(state.location) ? state.location : `${parseLocation(state.location).city},${parseLocation(state.location).state}`}&publisher=${site.rialto.publisher}&format=json&placement=searchFlex0&max=1`
  //         const response = await fetch(url)
  //         .catch( e => {
  //           console.debug(e)
  //         })
  //
  //         const json = await response.json()
  //
  //         if(json.errors){
  //           console.debug(JSON.stringify(json.errors))
  //         } else {
  //           setPriorityListing({ ...json?.ads[0] })
  //         }
  //       } catch(e){
  //         console.debug('e', e)
  //       }
  //     }
  //   }
  //   loadPriorityListingData()
  // }, [])

  const getPrettyLocation = () => {
    if(isZip(state.location)){
      return <React.Fragment>in <span className="highlight">{state.location}</span></React.Fragment>
    }
    const location = cleanLocation(state.location)
    if(location.city){
      return <React.Fragment>in <span className="highlight">{location.city}{location.state ? `, ${location.state}` : ''}</span></React.Fragment>
    }
    return ''
  }

  const updatePage = (page = 1) => {
    setState({
      ...state,
      page: page,
    })
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }

  return <div className="directory-list-container">
    {!state.isLoading && !state.isEmpty && <React.Fragment>
      <div className="container">
        <div className="page-container">
          <div className="main-wrapper">
            <h1>Search results for <span className="highlight term">{state.term}</span> {getPrettyLocation()}</h1>
            <div className="results-container">
              <PriorityListing listing={priorityListing} />
              <Featured results={state.results} />
              <div className="list-wrapper">
                <BusinessCards
                  isLoading={state.isLoading}
                  results={state.results}
                  city={state.city} />
              </div>
            </div>
            <Pagination
                page={state.page}
                perPage={state.rpp}
                resultsCount={state.total}
                updatePage={ page => updatePage(page) } />
          </div>
          <div className="rail-container">
            <TopBusinesses />
          </div>
        </div>
      </div>
    </React.Fragment>}
    {!state.isLoading && state.isEmpty && <div className="no-results-container">
      <div className="container">
        <h2>No matches found.</h2>
        <div className="search-form-wrapper">
          <h4>Try a new search</h4>
          <SearchForm />
        </div>
      </div>
    </div>}
    {state.isLoading && <div className="loading-container container">Loading...</div>}
    <Categories />
  </div>
}

export default DirectoryList
